import "../PagePresentation.scss"
import "./PageContact.scss";
import { useState } from "react";
import ModalContact from "./ModalContact";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";


const PageContact = () => {
  const [showModal, setModal] = useState(false);
  
   return (
   <>
    <div className="container text-center">
      <div className="row pt-2 pb-2 pb-2 mt-5">
        <div className="col col-md-10 offset-md-1 col-12  ">
          <div className="titre text-center">Contacter notre support</div>
          <div className="text-center">Une question ? Consulter notre aide en ligne ou contacter notre support via le formulaire ci-dessous.</div>
        </div>
      </div>
   
    <div className="row pt-4 pb-5 mb-5 ">
      <div className="col col-lg-5 offset-lg-1 col-12 mt-5 ">
        <Card className="module-card-smallheight">
          <Card.Header className="text-start">
            <i className="bi bi-question-circle"></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>{"Questions fréquentes"}</Card.Title>
              <div className="description pt-2 row">
                <div className="col-12"> 
                Trouver les réponses aux questions souvent posées.
                </div>
            </div>
          </Card.Body>
          <Card.Footer>
            <Link 
              to={"https://electreng.atlassian.net/wiki/spaces/AELEP/overview?homepageId=1839726899"} 
              className={"btn btn-secondary"} 
              style={{"width":"200px"}}
              target="_blank"
                        rel="noopener noreferrer"
                        >
                  Consulter l&apos;aide en ligne</Link>
          </Card.Footer>
        </Card>
      </div>
      <div className="col col-lg-5 col-12 mt-5">
        <Card className="module-card-smallheight">
        <Card.Header className="text-start">
          <i className="bi bi-envelope-at"></i>
        </Card.Header>
        <Card.Body>
          <Card.Title>{"Formulaire de contact"}</Card.Title>
            <div className="description pt-2 row">
              <div className="col-12"> 
              Posez-nous vos questions. Nous serons ravis de vous aider.
              </div>
          </div>
        </Card.Body>
        <Card.Footer>
        <Link 
            to={"#"} 
            className={"btn btn-secondary"} 
            style={{"width":"200px"}}
            rel="noopener noreferrer"
            onClick={() => {
              setModal(true);

            }}
                      >Contacter le support</Link>
        </Card.Footer>
      </Card>
      </div>
    </div>
    </div>
    <div className="p-3">&nbsp;</div>
        <ModalContact
        show={showModal}
        onHide={() => setModal(false)}
      />
   </>
    
  );
};

export default PageContact;
